import { ComponentPropsWithoutRef, FC } from 'react';

export type StatusPositiveIconProps = ComponentPropsWithoutRef<'svg'>;

export const StatusPositiveIcon: FC<StatusPositiveIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M6.93829 10.6274L11.5064 6.08013L10.7829 5.35659L6.93829 9.18032L5.20113 7.46396L4.47759 8.1875L6.93829 10.6274ZM8.00192 15.415C6.98592 15.415 6.02713 15.2218 5.12554 14.8354C4.22396 14.4489 3.43471 13.917 2.75779 13.2396C2.08088 12.5623 1.54951 11.7737 1.16369 10.8739C0.777871 9.97411 0.584961 9.01678 0.584961 8.00192C0.584961 6.97203 0.77819 6.00977 1.16465 5.11513C1.55109 4.22049 2.083 3.43471 2.76038 2.75779C3.43774 2.08088 4.22632 1.54951 5.12611 1.16369C6.0259 0.777871 6.98322 0.584961 7.99809 0.584961C9.02798 0.584961 9.99024 0.77819 10.8849 1.16465C11.7795 1.55109 12.5653 2.083 13.2422 2.76038C13.9191 3.43774 14.4505 4.22284 14.8363 5.11569C15.2221 6.00854 15.415 6.96934 15.415 7.99809C15.415 9.01409 15.2218 9.97288 14.8354 10.8745C14.4489 11.776 13.917 12.5653 13.2396 13.2422C12.5623 13.9191 11.7772 14.4505 10.8843 14.8363C9.99147 15.2221 9.03067 15.415 8.00192 15.415ZM7.99973 14.4159C9.77609 14.4159 11.2895 13.7907 12.5401 12.5403C13.7906 11.29 14.4159 9.77662 14.4159 8.00027C14.4159 6.22391 13.7907 4.71047 12.5403 3.45994C11.29 2.2094 9.77662 1.58413 8.00027 1.58413C6.22391 1.58413 4.71047 2.20931 3.45994 3.45967C2.2094 4.71003 1.58413 6.22338 1.58413 7.99973C1.58413 9.77609 2.20931 11.2895 3.45967 12.5401C4.71003 13.7906 6.22338 14.4159 7.99973 14.4159Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
